import React from 'react';
import './BackButton.less';

import BackIcon from 'new-images/back.svg';

export const BackButtonColors = {
	normal: 'normal',
	dark: 'dark'
}

const BackButtonColorClasses = {
	[BackButtonColors.normal]: 'back-button--normal',
	[BackButtonColors.dark]: 'back-button--dark'
}

export const BackButton = ({color = BackButtonColors.normal, onClick}) => {
	return <a
		className={`back-button ${BackButtonColorClasses[color]}`}
		onClick={onClick}
		dangerouslySetInnerHTML={{__html: BackIcon}}
	></a>;
};
